import styled from '@emotion/styled';
import {
  Button,
  InputField,
  InputSelectField,
  InputWrapper,
  InputRadio,
} from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const TopWrapper = styled.div<{ marginTop: number; marginBottom: number }>`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${(props) => `${props.marginTop}px`};
  margin-bottom: ${(props) => `${props.marginBottom}px`};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mediaQuery('tablet')} {
    // max-width: 700px;
    width: 100%;
  }

  ${mediaQuery('phone')} {
    margin-top: 0;
  }
`;

export const StepLineWrapper = styled.div`
  margin-top: 40px;
  padding: 40px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background-color: ${(props) => props.theme.color.light.default};

  ${mediaQuery('phone')} {
    margin-top: 0;
    padding: 20px;
  }
`;

export const OnboardingIconsContainer = styled.div<{ currentStep: number }>`
  width: 90%;
  margin: 20px 5% 0 5%;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  ${mediaQuery('phone')} {
    ${(props) =>
      props.currentStep === 13 &&
      `
      transform: translateY(70px);
      padding: 0 40px; 
      `}
    margin: 0 5% 0 5%;
  }
`;

export const OnboardingDog = styled.img<{ isEnd?: boolean; isStart?: boolean }>`
  width: 82px;
  height: 62px;
  margin: ${(props) => (props.isStart ? 0 : 'auto')};
  background-color: white;
  ${mediaQuery('phone')} {
    ${(props) => !props.isEnd && 'transform: translateY(10px)'};
    z-index: 10;
    // ${(props) => props.isEnd && 'display: none'}
  }
`;

export const OnboardingPrev = styled.img<{ currentStep: number }>`
  width: 33px;
  height: 33px;
  margin: start;
  cursor: pointer;
  ${mediaQuery('phone')} {
    margin-top: ${(props) => props.currentStep !== 12 && '60px'};
  }
`;

export const OnboardingClose = styled.img`
  width: 33px;
  height: 33px;
  margin: end;
`;

export const InputLabelSpan = styled.span`
  color: ${(props) => props.theme.color.blue.default};
  font-size: 14px;
  font-weight: 600;
  margin-left: 8px;
`;

export const Step0Container = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  margin-top: 25%;
  ${mediaQuery('phone')} {
    flex-direction: column-reverse;
    gap: 40px;
  }
`;

export const Step0SubContainer1 = styled.div`
  padding: 100px 40px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  ${mediaQuery('phone')} {
    padding: 50px 20px;
  }
`;

export const Step0Number = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
`;

export const Step0NumberContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Step0NumberText = styled.div`
  color: #616b77;
  font-weight: 600;
`;

export const Step0SubContainer2 = styled.div`
  width: 55%;
  display: flex;
  flex-direction: column;
  ${mediaQuery('phone')} {
    width: 90%;
  }
`;

export const Step0Header = styled.p`
  font-size: 27px;
  font-weight: bold;
  color: #20253f;
  margin-bottom: 0;
`;

export const Step0Paragraph = styled.p`
  font-size: 12px;
  color: #616b77;
  margin-top: 0;
`;

export const CreateButtonContainer = styled.div`
  width: fit-content;
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;

export const ProfilePictureWrapper = styled.div`
  height: 180px;
  width: 180px;
  margin-bottom: 40px;
  ${mediaQuery('phone')} {
    width: 100%;
    margin-bottom: 0;
  }
`;

export const SingleFileWrapper = styled.div`
  width: 100%;
  height: 130px;
`;

export const MultipleFilesWrapper = styled.div`
  width: 100%;
  min-height: 130px;
`;

export const MultiFileViewer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Step3Container = styled.div`
  display: grid;
`;

export const BlueInfoBox = styled.div<{ full?: boolean; isFlex?: boolean }>`
  ${(props) => (props.full ? 'width:100%' : 'width:70%')};
  ${(props) => (props.full ? ' padding: 14px 30px' : ' padding: 8px 10px')};
  ${(props) => !props.full && ' margin-bottom: 30px'};
  border-radius: 12px;
  border: 2px solid ${(props) => props.theme.color.blue.default};
  background-color: ${(props) => props.theme.color.blue.light};
  color: ${(props) => props.theme.color.blue.default};
  text-align: justify;
  font-weight: 600;
  font-size: 14px;
  max-width: 682px;
  margin: ${(props) => props.full && '25px auto'};
  display: ${(props) => (props.isFlex ? 'flex' : 'block')};
  margin-top: 0;
  align-items: center;
  ${mediaQuery('phone')} {
    height: auto;
  }
`;

export const BlueInfoBoxSpan = styled.span`
  font-weight: 700;
`;

export const TextareaContainer = styled.div`
  width: 100%;
  height: auto;
`;

export const Step5Textarea = styled.input`
  width: 100%;
  height: 135px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 16px;
  resize: both;
  max-height: 160px;
`;

export const Step6Main = styled.div`
  width: 41%;
  margin: 0 auto;
  margin-top: 50px;
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const FlexContainer2 = styled.div`
  display: flex;
  ${mediaQuery('phone')} {
    flex-wrap: wrap;
  }
`;

export const ButtonContainer = styled(Button)`
  text-align: center;
`;
// @Aida instead of modifying the original Button component style, create a new variant instead
export const OnboardingButton = styled(Button)<{ isFull?: boolean }>`
  width: ${(props) => (props.isFull ? '100%' : '178px')};
`;

export const OnboardingInputWrapper = styled(InputWrapper)<{ centered?: boolean }>`
  ${(props) => props.centered && 'margin: auto'};
  margin-bottom: ${(props) => (props.noMargin ? '0' : '30px')};
`;

export const OnboardingInputWrapperContainer = styled(OnboardingInputWrapper)`
  margin-top: 40px;
`;

export const OnboardingInputField = styled(InputField)`
  height: 65px;
`;

export const OnboardingInputSelectField = styled(InputSelectField)`
  height: 65px;
`;

export const Step12Container = styled.div`
  width: 50%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 30px;
`;
export const Step13Container = styled.div`
  width: 100%;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  ${mediaQuery('phone')} {
    border: none;
    border-radius: 0;
  }
`;

export const Step13Title = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: #20253f;
  margin: 10px 0;
`;

export const Step13Subtitle = styled.p`
  font-size: 14px;
  color: #616b77;
  margin: 0;
  margin-bottom: 30px;
`;

export const Step13SubContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const EditIcon = styled.div`
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 10;
  cursor: pointer;
`;
export const Step13SubContainerTitle = styled.p`
  font-weight: 700;
  color: #20253f;
  margin: 0;
  max-width: 80%;
  ${mediaQuery('phone')} {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const Step13SubContainerDesc = styled.p`
  font-size: 14px;
  color: #9ea1a8;
  margin: 0;
  margin-top: 5px;
`;

export const SpokenLanguagesContainer = styled.div`
  display: flex;
`;

export const Step13ImageSection = styled.div`
  display: flex;
  gap: 9%;
  margin: 20px 0;
  width: 100%;
  justify-content: start;
  align-items: center;
  padding-bottom: 20px;
`;

export const Step13ImageType = styled.p`
  font-size: 10px;
  font-weight: 600;
  color: #20253f;
`;

export const Step13DocSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
`;

export const Document = styled.a<{ href: string; multi?: boolean }>`
  border-radius: 15px;
  ${(props) => (props.multi ? 'width: 40%' : 'width: 100%')};
  margin-right: 6px;
  height: 50px;
  background-color: #f8f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;

export const MultiDocumentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  ${mediaQuery('phone')} {
    flex-direction: column;
  }
`;

export const DocContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10%;
  ${mediaQuery('phone')} {
    flex-direction: column;
    justify-content: space-between;
    gap: 0;
  }
`;

export const DocTextsContainer = styled.div`
  width: 75%;
  ${mediaQuery('phone')} {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const Picture = styled.p`
  color: #616b77;
  font-size: 14px;
  margin: 0;
`;

export const MainImage = styled.div<{ src: string }>`
  background: url(${(props) => props.src}) center center no-repeat;
  background-size: cover;
  cursor: pointer;
  width: 94px;
  height: 94px;
  border-radius: 10px;
`;

export const Skeleton = styled.div`
  width: 94px;
  height: 94px;
  border-radius: 10px;
  border: 1px solid #5acee8;
  background-color: #e0f5fb;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Step12MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Step13ImageSubsection = styled.div`
  display: flex;
  align-items: center;
  width: 90%;
  gap: 2%;
  ${mediaQuery('phone')} {
    flex-direction: column;
  }
  ${mediaQuery('tablet')} {
    flex-direction: column;
  }
`;

export const Step13Kennel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Step2Warn = styled.div<{ full?: boolean }>`
  ${(props) => (props.full ? 'width:100%' : 'width:70%')};
  border: 2px solid #5acee8;
  ${(props) => (props.full ? ' padding: 14px 30px' : ' padding: 8px 0')};
  ${(props) => !props.full && ' margin-bottom: 30px'};
  border-radius: 12px;
  background-color: #e0f5fb;
  color: #5acee8;
  text-align: center;
  font-weight: 600;
`;

export const Step2WarnSPam = styled.span`
  font-weight: 700;
`;

export const ImageContainer = styled.div`
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
`;

export const ImageWrapper = styled.div<{ imagesAmount: number }>`
  ${(props) => {
    if (props.imagesAmount <= 6) {
      return { width: '33%', height: '180px' };
    }

    if (props.imagesAmount > 6 && props.imagesAmount <= 12) {
      return { width: '25%', height: '120px' };
    }

    return { width: '100%', height: '178px' };
  }};
  max-width: 178px;

  ${mediaQuery('phone')} {
    max-width: 100%;
    width: 100%;
    margin-bottom: 0;
  }
`;

export const AddImage = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 178px;
  border: 2px solid #d7dae0;
  border-radius: 10px;
  background: #f8f8f8;
`;

export const ErrorText = styled.div`
  margin-top: 5px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.theme.color.red.default};
  text-align: left;
`;

export const NoFileLabel = styled.div`
  align-self: center;
  width: 100%;
  font-size: 14px;
  color: #9ea1a8;
  margin: 0;
  margin-top: 5px;
  text-align: center;
`;
